define("settings/components/plan-recommendation/recommendation", ["exports", "@ember/component", "@glimmer/component", "settings/utils/plan-score", "@ember/template-factory"], function (_exports, _component, _component2, _planScore, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"settings/utils/plan-score",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div data-test-id="plan-recommendation-recommendation" data-test-tier={{this.recommendation.tier}} ...attributes>
    <PlanRecommendation::PlanCard @answers={{@answers}} @recommendation={{this.recommendation}} />
  </div>
  */
  {
    "id": "XgM1yp/g",
    "block": "[[[11,0],[24,\"data-test-id\",\"plan-recommendation-recommendation\"],[16,\"data-test-tier\",[30,0,[\"recommendation\",\"tier\"]]],[17,1],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@answers\",\"@recommendation\"],[[30,2],[30,0,[\"recommendation\"]]]],null],[1,\"\\n\"],[13]],[\"&attrs\",\"@answers\"],false,[\"plan-recommendation/plan-card\"]]",
    "moduleName": "settings/components/plan-recommendation/recommendation.hbs",
    "isStrictMode": false
  });
  class RecommendationComponent extends _component2.default {
    constructor() {
      super(...arguments);
      /** A field initializer runs once per instance, and the wizard builds a slide only when it becomes active; a getter would rescore on every re-render. */
      _defineProperty(this, "recommendation", (0, _planScore.recommendPlan)(this.args.answers));
    }
  }
  _exports.default = RecommendationComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RecommendationComponent);
});